let token: string;

function getToken(): string {
  return token;
}

function setToken(v: string): void {
  token = v;
}

export const ServerApiStore = {
  getToken,
  setToken,
};
